import { useQuery } from "@tanstack/react-query";

import { listSilverVersions } from "services";

import { LIST_SILVER_VERSIONS } from "consts";

export const useSilverVersions = () =>
  useQuery({
    queryKey: [LIST_SILVER_VERSIONS],
    queryFn: listSilverVersions,
  });
